<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'申请政策申报审核',goback:true},{name:'申请政策申报审核详情'}]" :title="'申请政策申报审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{detailInfo.user.userName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">账号类型：</div>
                            <div class="content">{{detailInfo.user.userTypeName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{detailInfo.user.realName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">邮箱：</div>
                            <div class="content">{{detailInfo.user.email}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">联系地址：</div>
                            <div class="content">{{detailInfo.user.contactAddress}}</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="提交信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{detailInfo.applicant}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detailInfo.contactPhone}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{detailInfo.applyCompany}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.applyRemark}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detailInfo.createTime}}</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
               <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{detailInfo.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detailInfo.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detailInfo.checkTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.checkExplanation}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detailInfo:{
                user:{
                    userName:'',
                    userTypeName:'',
                    realName:'',
                    email:'',
                    contactAddress:'',
                },
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                checkStatusValue:"",
                modifyUserName:"",
                checkTime:"",
                checkExplanation:"",
            },
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
        }
    },
    methods:{
        
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/policy/declare/apply/details/'+this.id)
          if (code == 200) {            
              this.detailInfo = data
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>